module.exports = __webpack_public_path__ + "static/media/clocards-edit.d5c8b210.png";